<template>
    <div>
        <department :model ="items"/>
    </div>
</template>
<script>

import Department from '../_shared/Department.vue'

export default {
  name: 'ContentTypeDepartment',
  components: { Department },
  props: ['model'],
  computed: {
    items: function () {
      return this.model.content
    }
  }
}
</script>
